import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { REPLACE_AIR } from "../../replace_str_constant";
import { useDispatch, useSelector } from "react-redux";
import {
  clearGameLink,
  openGame,
  startGameLoading,
  storeGameConfig,
  triggerGame,
} from "../../redux/action/game/gameAction";
import LazyImage from "../Loading/lazyImage";
import LoadingLine from "../Loading/LoadingLine";
import { COMMON_WEB_PATH } from "../../constant";
import useDeviceType from "../../hook/useDeviceType";
import { useTranslation } from "react-i18next";
import { CloseMenu, globalTrigger } from "../../redux/action/action";
import { languageTransfer } from "../../utils/languageTransfer";
import i18next from "i18next";
import { BsTools } from "react-icons/bs";
import { BiSolidTag } from "react-icons/bi";
import { enterPlayGame } from "../../api/postApi";
import { isLoggedIn } from "../../utils/isLoggedIn";

const GAMEITEM = ({
  originProps,
  gameProps,
  customWidth,
  itemClass,
  specMask,
  isHot,
  itemIndex,
  forceShow,
}) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const { gameCode, platform, gameName, gameNameEn, gameSubType } = gameProps;

  const isMobile = useDeviceType() === "Mobile";

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);

  const { allGamePlatform = [] } = isHandleAllGame;

  const dispatch = useDispatch();
  //把Redux store 中的 isHandleAllGame 属性，儲存在 handleAllGame 變量中

  const navigate = useNavigate();
  const location = useLocation();

  const getPrevPath = useMemo(() => {
    const path = location.pathname.split("/");
    const currentPathIndex = path.findIndex((item) => item === "game-confirm");

    if (currentPathIndex === -1) return "";

    return `${path.slice(0, currentPathIndex).join("/")}/`;
  }, [location.pathname]);

  const getPlatformIsMaintain = useMemo(() => {
    const findPlatform = allGamePlatform.find(
      (item) => item.platform === platform
    );
    const { maintenanceEndTime, maintenanceStartTime } = findPlatform || {};
    const isMaintain = findPlatform?.isUnderMaintenance;
    if (isMaintain) {
      return {
        state: true,
        component: (
          <div className="bg-[rgb(0,0,0,0.7)] absolute top-0 left-0 w-full h-full z-[2] rounded-[5px] flex flex-col gap-[10px] justify-center items-center text-base-light-white">
            <BsTools className="text-4xl" />
            <div className="flex flex-col items-center justify-center text-xs font-medium">
              {maintenanceStartTime ? (
                <>
                  <span>{maintenanceStartTime}</span>
                  <span>~</span>
                  <span>{maintenanceEndTime}</span>
                </>
              ) : (
                <>
                  <span>{i18n_common("platformMaintain")}</span>
                </>
              )}
            </div>
          </div>
        ),
      };
    }
  }, [platform]);
  const handleEnterGame = useCallback(() => {
    if (getPlatformIsMaintain?.state) return;
    dispatch(storeGameConfig(originProps));
    dispatch(clearGameLink());
    dispatch(CloseMenu());
    dispatch(startGameLoading());
    if (isMobile) {
      navigate(
        `${getPrevPath}game-confirm/${gameName}/${originProps.game_platform}/${originProps.gameUid}`
      );
    } else {
      navigate(
        `/gamebox/${gameName}/${originProps.game_platform}/${originProps.gameUid}`
      );
    }
  }, [originProps, gameName]);

  const classList = useMemo(() => {
    let classes = `rounded-t-[5px] lg:h-[185px] md:h-[160px] h-[130px] xl:min-w-[110px] transition relative cursor-pointer overflow-hidden`;
    if (customWidth) classes += ` ${customWidth}`;
    if (itemClass) classes += ` ${itemClass}`;
    return classes;
  }, [customWidth, itemClass]);

  return (
    <div
      onClick={handleEnterGame}
      className={`flex flex-col relative cursor-pointer ${
        getPlatformIsMaintain?.state
          ? `md:hover:bg-none cursor-not-allow ${forceShow ? "" : "hidden"}`
          : specMask
          ? "md:hover:bg-[rgb(0,0,0,0.1)] group"
          : "md:hover:bg-[#FF7900] group"
      } bg-base-light-white dark:bg-base-light-dark rounded-[5px]`}
    >
      {getPlatformIsMaintain?.component}
      {isHot && itemIndex + 1 < 11 ? (
        <div className="">
          <BiSolidTag className="rotate-[-90deg] text-[55px] text-[#E40A13] absolute top-[-5px] right-[-7px] z-[1]" />
          <div className="absolute top-[0px] right-[0px] gap-[-5px] z-[1] w-[41px] h-[43px] flex flex-col items-center justify-center font-bold text-white z-[1]">
            <span className="text-sm tracking-tighter">Top</span>
            <span>10</span>
          </div>
        </div>
      ) : null}
      <div className={classList}>
        <LazyImage
          src={`${COMMON_WEB_PATH}/gameIcon/en/${platform}/${REPLACE_AIR(
            gameCode
          )}.webp`}
          alt={gameNameEn}
          closeInverted
          className={`w-full h-full rounded-t-[5px] !object-cover ${
            specMask ? "object-scale-down" : "object-cover"
          }`}
        />
        <section
          className={`absolute ${
            specMask ? "bg-[rgba(0,0,0,0.6)]" : "bg-[rgba(255,102,2,0.6)]"
          } top-0 left-0 h-full w-full rounded-[5px] md:group-hover:opacity-100 hidden opacity-0 duration-300 md:flex items-center justify-center`}
        >
          <button
            type="button"
            className="bg-[#FD9103] rounded-xl border border-[#ECBE8C] py-[5px] px-[20px] flex items-center justify-center font-extrabold text-white text-lg"
            onClick={handleEnterGame}
          >
            <span>PLAY</span>
          </button>
        </section>
      </div>
      <div className="flex flex-col gap-[0px] p-[5px]">
        <LoadingLine className="md:group-hover:!bg-[FF7900] !w-[100px]">
          <p className="md:group-hover:text-white text-base-light-dark dark:text-base-light-white text-medium mb-0 text-overflow w-full">
            {originProps?.[
              `gameName${languageTransfer({ lang: i18next.language })}`
            ] || "-"}
          </p>
        </LoadingLine>
        <LoadingLine className="md:group-hover:!bg-[FF7900] !w-[50px]">
          <p className="md:group-hover:text-white text-[rgb(170,170,170)] text-sm font-medium mb-0 text-overflow w-full">
            {platform} - {i18n_common(gameSubType)}
          </p>
        </LoadingLine>
      </div>
    </div>
  );
};

export default React.memo(GAMEITEM);
